<div class="modal-header">
  <h1 style="margin: 0; font-size: 20px;">What time do you want your order?</h1>
  <button mat-icon-button (click)="closeModalById('order-wanted-time-modal')">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div style="padding: 0 20px 20px;">
  <div style="text-align: center; margin: 5px 0 10px;">
    @if (alertMessages?.length > 0) {
      @for (messages of alertMessages; track messages) {
        <span class="alert-message">{{ messages }}</span>
      }
    }

    @if (wantedTimeIssue && (!alertMessages || alertMessages.length === 0)) {
      <span class="alert-message">{{ wantedTimeIssue }}</span>
    }
  </div>

  @if (isLoading) {
    <div style="min-height: 100px;" class="flex-row-centered">
      <div class="lds-dual-ring"></div>
    </div>
  }

  @if (timeSlots.length > 0) {
    @if (!isLoading) {
      <mat-form-field class="slots-dropdown">
        <mat-select placeholder="Select a time" [(value)]="initialTime" (selectionChange)="orderTimePicked($event)">
          @for (slot of timeSlots; track slot) {
            <mat-option [value]="slot.time" [disabled]="slot.disabled">
              {{ slot.title }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>access_time</mat-icon>
      </mat-form-field>
    }
    <button class="button-action-1"
            style="width: 100%;"
            (click)="orderNow()"
            [disabled]="disableContinueButton || isLoading"
            [class.button-action-disabled]="disableContinueButton || isLoading">Continue</button>
  }

  @if (futureTimeSlots?.length > 0) {
    <div class="flex-row-centered" style="margin-top: 20px;" (click)="openFutureDatePicker()">
      <span class="wanted-time-hyperlink">{{ orText }}order for a future date</span>
    </div>
  }
</div>

<ng-template #futureTimePicker>
  <app-future-wanted-time-picker [slots]="futureTimeSlots"
                                 [wantedTimeUtc]="basket.WantedTimeUtc"
                                 [useBasketForInitialTime]="useBasketForInitialTime()"
                                 (onConfirmSelection)="orderNow($event)"></app-future-wanted-time-picker>
</ng-template>
